<form #profileForm="ngForm" (ngSubmit)="handleContinue()">
  <div class="flex flex-column justify-content-center align-items-center bg-landing sm:h-screen sm:p-4">
    <div class="flex justify-content-end w-full px-3 pt-3 sm:px-0 sm:pt-0">
      <app-language-config></app-language-config>
    </div>
    <div class="flex flex-1 align-items-center justify-content-center w-full">
      <div class="bg-white border-round-2xl p-4 sm:p-6 w-full h-max" style="max-width: 584px">
        <div class="flex flex-column gap-4">
          <div class="flex flex-column gap-3">
            <div class="flex justify-content-center">
              <app-upload-image
                [userImg]="true"
                [path]="formUserProfile().avatarUrl"
                (OnUpload)="onUploadImgUser($event, profileForm.form)"
                (OnDelete)="onDeleteImgUser($event, profileForm.form)"
              ></app-upload-image>
            </div>
            <div class="flex flex-column sm:flex-row gap-3">
              <div class="flex flex-column gap-2 w-full">
                <label class="text-sm text-color font-normal" for="firstName">
                  {{ 'first_name' | transloco }}
                  <span class="text-red-600">*</span>
                </label>
                <input
                  pInputText
                  id="firstName"
                  name="firstName"
                  [(ngModel)]="formUserProfile().firstName"
                  [appNoneSpecialChar]="true"
                  required
                />
              </div>
              <div class="flex flex-column gap-2 w-full">
                <label class="text-sm text-color font-normal" for="lastName">
                  {{ 'last_name' | transloco }}
                  <span class="text-red-600">*</span>
                </label>
                <input
                  pInputText
                  id="lastName"
                  name="lastName"
                  [(ngModel)]="formUserProfile().lastName"
                  [appNoneSpecialChar]="true"
                  required
                />
              </div>
            </div>
            <div class="flex flex-column sm:flex-row gap-3">
              <div class="flex flex-column gap-2 w-full">
                <label class="text-sm text-color font-normal" for="nickname">{{ 'nickname' | transloco }}</label>
                <input pInputText id="nickname" name="nickname" [(ngModel)]="formUserProfile().nickname" [appNoneSpecialChar]="true" />
              </div>
            </div>
          </div>

          <div class="flex flex-column gap-3">
            <p class="text-base text-color font-semibold">{{ 'business.info' | transloco }}</p>
            <div class="flex flex-column sm:flex-row gap-3">
              <div class="flex flex-column gap-2 w-full">
                <label class="text-sm text-color font-normal" for="name">
                  {{ 'business.name' | transloco }}
                  <span class="text-red-600">*</span>
                </label>
                <input
                  pInputText
                  id="name"
                  name="name"
                  [(ngModel)]="formUserProfile().name"
                  (input)="validateBusinessNameInput($event)"
                  [class]="isDuplicateNameSignal() ? 'ng-invalid ng-dirty' : ''"
                  [appTrim]="true"
                  maxlength="30"
                  required
                />
              </div>
            </div>
          </div>

          <div class="flex flex-column gap-3">
            <p class="text-base text-color font-semibold">{{ 'user_contact_info' | transloco }}</p>
            <div class="flex flex-column sm:flex-row gap-3">
              <div class="flex flex-column gap-2 w-full">
                <label class="text-sm text-color font-normal" for="email">{{ 'e-mail' | transloco }}</label>
                <input
                  pInputText
                  type="email"
                  id="email"
                  name="email"
                  [(ngModel)]="formUserProfile().email"
                  [disabled]="true"
                  [email]="true"
                  required
                />
              </div>
              <!-- <div class="flex flex-column gap-2 w-full">
                <label class="text-sm text-color font-normal" for="phoneNumber">{{ 'phone_number' | transloco }}</label>
                <p-inputMask
                  inputId="phoneNumber"
                  name="phoneNumber"
                  mask="999-999-9999"
                  [(ngModel)]="formUserProfile().mobile"
                  styleClass="w-full"
                />
              </div> -->
            </div>

            <app-country-phone-select (phoneChange)="onMobileChange($event)"></app-country-phone-select>

            @if (!hasSyncWithLine()) {
              <div class="w-full sm:w-6 pr-0 sm:pr-2">
                <p-button
                  [label]="'sync_with_line' | transloco"
                  severity="success"
                  styleClass="w-full flex align-items-center justify-content-start gap-2 px-0"
                  (onClick)="linkAccountHandler('line')"
                >
                  <ng-template pTemplate="icon">
                    <div class="flex align-items-center pr-2 border-right-1" style="border-color: #00000025">
                      <p-image
                        [src]="imageLineSignal()"
                        alt="line"
                        imageClass="flex px-2"
                        [imageStyle]="{ width: '40px', height: '22px' }"
                      />
                    </div>
                  </ng-template>
                </p-button>
              </div>

              <!-- <div class="w-full sm:w-6 pr-0 sm:pr-2">
                <p-button
                  [label]="'sync_with_line' | transloco"
                  severity="success"
                  styleClass="w-full px-0"
                  (onClick)="linkAccountHandler('line')"
                >
                  <ng-template pTemplate="icon">
                    <div class="border-right-1" style="border-color: #00000025">
                      <p-image
                        [src]="imageLineSignal()"
                        alt="line"
                        imageClass="flex px-2"
                        [imageStyle]="{ width: '40px', height: '22px' }"
                      />
                    </div>
                  </ng-template>
                </p-button>
              </div> -->
            } @else {
              <div class="bg-white border-1 border-round-xl border-200" style="padding: 12px 16px">
                <div class="flex justify-content-between align-items-center">
                  <div class="flex align-items-center gap-3">
                    <p-image [src]="imageLineGreenSignal()" alt="line-green" [imageStyle]="{ width: '40px', height: '40px' }" />
                    <p class="text-sm text-color font-normal">{{ 'sync_with_line' | transloco }}</p>
                  </div>
                  <p-button
                    [label]="'connect.disconnect' | transloco"
                    severity="info"
                    [text]="true"
                    (click)="unlinkAccountHandler('line')"
                  />
                </div>
              </div>
            }

            <!-- [style]="{ display: 'block', width: '100%', margin: '0 auto' }" -->
            <p-button
              type="submit"
              [label]="'continue' | transloco"
              [loading]="loadingButtonSignal()"
              [disabled]="!disableBtn(profileForm.form) || !isValidPhoneSignal()"
              [style]="{ width: '100%' }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<app-dialog-alert [dataDialog]="dialogAlertSignal()" (OnHide)="onCloseDialog()"></app-dialog-alert>
